var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('v-container',{staticClass:"font-nanumsquare",attrs:{"id":"funda-main","fluid":""}},[_c('router-view',{key:_vm.$route.fullPath + '&' + _vm.$store.state.time.current})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }